import {addIcons} from 'ionicons';
import {
  radioButtonOn,
  radioButtonOff,
  caretDown,
  caretUp,
  caretDownOutline,
  caretUpOutline,
  backspace,
  chevronBack,
  arrowForwardCircleOutline,
  addCircleOutline,
  calendarClearOutline,
  optionsOutline,
  reorderThreeOutline,
  pencilOutline,
  trash,
  removeCircleOutline,
  shareOutline,
  alertCircleOutline,
  chevronForwardOutline,
  remove,
  shareSocialOutline,
  fingerPrintOutline,
  eyeOutline,
  ellipsisHorizontal,
  globeOutline,
  warningOutline
} from 'ionicons/icons';

export const registerIcons = (): void => {
  addIcons({
    'radio-button-on': radioButtonOn,
    'radio-button-off': radioButtonOff,
    'caret-down': caretDown,
    'caret-up': caretUp,
    'caret-down-outline': caretDownOutline,
    'caret-up-outline': caretUpOutline,
    backspace,
    'chevron-back': chevronBack,
    'arrow-forward-circle-outline': arrowForwardCircleOutline,
    'add-circle-outline': addCircleOutline,
    'calendar-clear-outline': calendarClearOutline,
    'options-outline': optionsOutline,
    'reorder-three-outline': reorderThreeOutline,
    'pencil-outline': pencilOutline,
    trash,
    'remove-circle-outline': removeCircleOutline,
    'share-outline': shareOutline,
    'alert-circle-outline': alertCircleOutline,
    'chevron-forward-outline': chevronForwardOutline,
    remove,
    'share-social-outline': shareSocialOutline,
    'finger-print-outline': fingerPrintOutline,
    'eye-outline': eyeOutline,
    'ellipsis-horizontal': ellipsisHorizontal,
    'globe-outline': globeOutline,
    'warning-outline': warningOutline
  });
};
